import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
import { baseUtils } from '../utils/baseUtils';
import window from '../sdk/windowWrapper';
import AppSettings from './appSettings';
import { experimentsWrapper } from '../sdk/experimentsWrapper';

var GallerySettings = /*#__PURE__*/function () {
  function GallerySettings() {
    var _this = this;

    try {
      this.protocol = window.location.protocol;
      this.galleryId = window.galleryId;
      this.instance = window.instance;
    } catch (e) {
      this.protocol = 'http:';
      this.galleryId = '';
      this.instance = '';
    }

    this.baseUrl = this.protocol + '//progallery.wixapps.net/_api/pro-gallery-editor-webapp/v1/gallery/';

    this.getGallerySettingsApi = function () {
      return "" + _this.baseUrl + _this.galleryId + "?instance=" + _this.instance + "&isStore=" + baseUtils.isStoreGallery();
    };

    this.appSettings = new AppSettings();
  }

  var _proto = GallerySettings.prototype;

  _proto.get = function get(key) {
    return axios.get(this.getGallerySettingsApi(), {
      withCredentials: true,
      xsrfCookieName: null
    }).then(function (_ref) {
      var data = _ref.data;
      return key ? data.settings[key] : data.settings;
    });
  };

  _proto.set = function set(key, value) {
    var _this2 = this;

    return this.get().then(function (data) {
      var _Object$assign;

      data = data || {};
      var settings = Object.assign(data, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
      return axios.put(_this2.getGallerySettingsApi(), {
        settings: settings
      }, {
        withCredentials: true,
        xsrfCookieName: null
      }).then(function () {
        return baseUtils.setExternalId();
      });
    });
  };

  _proto.setAppSettings = /*#__PURE__*/function () {
    var _setAppSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                _context.next = 11;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return this.appSettings.set(key, value);

            case 4:
              baseUtils.setExternalId();
              return _context.abrupt("return", Promise.resolve());

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error('Failed to set ' + key + ' in appSettings: ' + _context.t0);

            case 11:
              this.set(key, value);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));

    function setAppSettings(_x, _x2) {
      return _setAppSettings.apply(this, arguments);
    }

    return setAppSettings;
  }();

  return GallerySettings;
}();

var gallerySettings = new GallerySettings();
export default gallerySettings;